import { type FC } from 'react';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Image, Radio, RadioGroup } from '@chakra-ui/react';
import { ChallengeRequestScreenState } from '@shinetools/sca-operations';
import {
  Button,
  Typography,
  XStack,
  YStack,
} from '@shinetools/sunshine-universal';
import { View } from '@tamagui/core';

import DialPhone from 'assets/brand/DialPhone.png';
import SunshineModal from 'components/_core/SunshineModal';

import { modalMinHeight } from '../utils/constant';

export type PhoneCallAnswer = 'yes' | 'no' | '' | 'withoutAnswer';

export interface ChallengeRequestPhoneCallProps {
  moveState: (state: ChallengeRequestScreenState) => void;
}

const ChallengeRequestPhoneCall: FC<ChallengeRequestPhoneCallProps> = ({
  moveState,
}) => {
  const [areYouInPhoneCall, setAreYouInPhoneCall] =
    useState<PhoneCallAnswer>('');

  const continueTo = useCallback(() => {
    if (areYouInPhoneCall === 'yes') {
      moveState(ChallengeRequestScreenState.FraudRisk);
    } else if (areYouInPhoneCall === 'no') {
      moveState(ChallengeRequestScreenState.Confirm);
    }
  }, [moveState, areYouInPhoneCall]);

  return (
    <>
      <SunshineModal.Body minHeight={modalMinHeight}>
        <YStack alignItems="center" gap={24} paddingBottom="$space.24">
          <Image
            src={DialPhone}
            style={{
              marginBottom: 24,
              opacity: 1,
              width: '30%',
            }}
          />

          <Typography.Header>
            <FormattedMessage id="authentication.challenge.phoneCall.title" />
          </Typography.Header>

          <RadioGroup
            onChange={(newVal: string) => {
              setAreYouInPhoneCall(newVal as PhoneCallAnswer);
            }}
            value={areYouInPhoneCall}
          >
            <XStack gap={16}>
              <View
                style={{
                  borderColor: '#ccc',
                  borderRadius: 4,
                  borderWidth: 1,
                  padding: 10,
                  paddingRight: 50,
                }}
              >
                <Radio value="yes">
                  <FormattedMessage id="authentication.challenge.phoneCall.yes" />
                </Radio>
              </View>
              <View
                style={{
                  borderColor: '#ccc',
                  borderRadius: 4,
                  borderWidth: 1,
                  padding: 10,
                  paddingRight: 50,
                }}
              >
                <Radio value="no">
                  <FormattedMessage id="authentication.challenge.phoneCall.no" />
                </Radio>
              </View>
            </XStack>
          </RadioGroup>
        </YStack>
      </SunshineModal.Body>
      <SunshineModal.Footer flexDirection="row">
        <View>
          <Button
            onPress={() => moveState(ChallengeRequestScreenState.Declined)}
            variant="tertiary"
          >
            <FormattedMessage id="authentication.close" />
          </Button>
        </View>

        <View marginLeft="70%">
          <Button
            isDisabled={
              areYouInPhoneCall === '' || areYouInPhoneCall === 'withoutAnswer'
            }
            onPress={() => continueTo()}
          >
            <FormattedMessage id="authentication.continue" />
          </Button>
        </View>
      </SunshineModal.Footer>
    </>
  );
};

export default ChallengeRequestPhoneCall;
